import styled from 'styled-components';

export const RequirementsContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: var(--spacing-small);
    margin: 0px var(--spacing-small) var(--spacing-regular) var(--spacing-small);

    @media (max-width: 1280px) {
        gap: 4px;
        margin: 0px var(--spacing-small) var(--spacing-small) var(--spacing-small);
    }
`;

export const RequirementItem = styled.div`
    display: flex;
    align-items: center;

    @media (max-width: 1280px) {
        .ant-typography {
            font-size: var(--font-small) !important;
        }
    }
`;
